import axios from "../config";

export const getStaffProfiles = () => {
  return axios.get("/staff-profile?sort=preferredName:ASC");
};

export const getStaffProfileById = (id) => {
  return axios.get(`/staff-profile/${id}`);
};

/**
 * Queue the same email for many staff members. The request is accepted once
 * the recipients are valid; sending continues after the response.
 * @param {Object} payload
 * @param {Array<string>} payload.staff staff-profile ids to email
 * @param {string} payload.subject
 * @param {string} payload.body HTML body from the compose editor
 * @param {Array<string>} [payload.attachments] uploaded attachment ids
 */
export const sendBulkEmailToStaff = (payload) => {
  return axios.post("/staff-profile/bulk-email", payload);
};
